import React, { Component } from "react";
import { connect } from "react-redux";
import { RackLocation } from "../../../../PickerOrder/PickerOrderPage/PickerOrderPage.styled";
import { Divider, Empty, InputNumber, Modal, Select, Tag, message } from "antd";
import { BsFillExclamationTriangleFill } from "react-icons/bs";
import {
  PickerRackModalWrapper,
  RackPickDone,
} from "./PickerRackLocation.styled";
import { getReasonsListThunk } from "../../../../../redux/PickerTO/Action";
import { IoCheckmarkDoneCircleSharp } from "react-icons/io5";

const { Option } = Select;

export class PickerRackLocation extends Component {
  state = {
    rackIssueModal: false,
    currValue: null,
    currRackQty: 0,
    disableSubmit: true,
    finalRackQty: null,
    currReason: null,
    runnerData: [],
  };

  numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  labelValue = (label, value, highlight) => {
    let isNum = typeof value === "number" ? true : false;

    return (
      <>
        <label>{label} </label>
        <p className={highlight ? "active" : ""}>
          {value ? (isNum ? this.numberWithCommas(value) : value) : "-"}
        </p>
      </>
    );
  };

  fetchReasonMaster = (location, isJit) => {
    // if (this.props.rackLocation?.remainingQuantity == 0) {
    //   message.info("Please pick medicine");
    // } else {
    this.props
      .getReasonsListThunk({
        access_token: this.props.access_token,
        reasonType: "RACK_ISSUE_REASON",
      })
      .then(() => {
        if (this.props.reasonsListFailure) {
          message.error(this.props.reasonsListFailure);
          this.setState({
            rackIssueModal: false,
          });
        } else {
          this.setState({
            runnerData: this.props.reasonsListSuccess,
            rackIssueModal: true,
            currValue: location,
            isJit: isJit,
          });
        }
      });
    // }
  };

  nullCheck = (value) => {
    let isNull = false;

    if (value && value?.trim()?.length > 0) {
      isNull = false;
    } else {
      isNull = true;
    }

    return isNull;
  };

  checkPickingQty = (e, checkQty) => {
    if (e <= checkQty) {
      this.setState({
        currRackQty: e ?? 0,
        currReason:
          e == this.props.rackLocation?.remainingQuantity
            ? null
            : this.state.currReason,
      });
    }
  };

  render() {
    let { rackLocation, rackApi } = this.props;

    let { finalRackQty } = this.state;

    let data = {
      isJit: this.state.isJit,
      pickedQty: this.state.currRackQty,
      reasonId:
        this.state.currRackQty == rackLocation?.remainingQuantity
          ? null
          : this.state.currReason,
    };

    data.jitLocation = !this.nullCheck(rackLocation?.jitLocation)
      ? rackLocation?.jitLocation
      : null;
    data.bulkLocation = !this.nullCheck(rackLocation?.bulkLocation)
      ? rackLocation?.bulkLocation
      : null;

    let availableQuantity = rackLocation?.availableQuantity
      ? parseInt(rackLocation?.availableQuantity)
      : 0;
    let remainingQuantity = rackLocation?.remainingQuantity
      ? parseInt(rackLocation?.remainingQuantity)
      : 0;
    let currRackQty = this.state.currRackQty
      ? parseInt(this.state.currRackQty)
      : 0;
    let checkQty =
      availableQuantity < remainingQuantity
        ? availableQuantity
        : remainingQuantity;

    return (
      <>
        {rackLocation &&
        rackLocation?.remainingQuantity != 0 &&
        (rackLocation?.jitLocation || rackLocation?.bulkLocation) ? (
          <RackLocation
            bothLocationAvailable={
              rackLocation?.jitLocation && rackLocation?.bulkLocation
                ? true
                : false
            }
          >
            <div className="issue">
              {" "}
              <BsFillExclamationTriangleFill /> Verify Rack Quantity
            </div>

            {rackLocation?.jitLocation ? (
              <div
                onClick={() =>
                  this.fetchReasonMaster(rackLocation?.jitLocation, true)
                }
              >
                <p>JIT Location:</p>
                <p>{rackLocation?.jitLocation}</p>
              </div>
            ) : null}
            {rackLocation?.bulkLocation ? (
              <div
                onClick={() =>
                  this.fetchReasonMaster(rackLocation?.bulkLocation, false)
                }
              >
                <p>Bulk Location:</p>
                <p>{rackLocation?.bulkLocation}</p>
              </div>
            ) : null}
          </RackLocation>
        ) : rackLocation?.remainingQuantity == 0 ? (
          <RackPickDone>
            <div className="wrapper">
              <IoCheckmarkDoneCircleSharp />
              Rack picking completed
            </div>
          </RackPickDone>
        ) : (
          <Empty
            style={{ margin: "5vh 0" }}
            description={
              <>
                <p>No Rack locations found</p>
                <Tag color="red" bordered={false}>
                  Please mark medicine issue
                </Tag>
              </>
            }
          />
        )}

        <Modal
          title={`${this.state.isJit ? "jit" : "bulk"} ${
            this.state.currValue
          } fullfill your medicine quantity ?`}
          open={this.state.rackIssueModal}
          centered
          closeIcon={null}
          onOk={() => {
            this.setState({
              rackIssueModal: false,
              currRackQty: 0,
              disableSubmit: true,
              finalRackQty: null,
              currReason: null,
            });
            rackApi(data);
          }}
          okText={"SUBMIT"}
          okButtonProps={{
            disabled:
              rackLocation?.remainingQuantity == 0 ||
              typeof this.state.currRackQty !== "number" ||
              (currRackQty < checkQty ? !this.state.currReason : false) ||
              this.state.disableSubmit,
          }}
          // cancelText={"YES"}
          onCancel={() =>
            this.setState({
              rackIssueModal: false,
              currRackQty: 0,
              disableSubmit: true,
              finalRackQty: null,
              currReason: null,
            })
          }
        >
          <PickerRackModalWrapper>
            <div className="quantityWrapper">
              <div className="quantityInfoWrapper">
                {this.labelValue(
                  `Current Rack :`,
                  `${this.state.isJit ? "JIT" : "Bulk"} ${this.state.currValue}`
                )}
                {this.labelValue(`Current Batch :`, rackLocation?.batchNumber)}
                {this.labelValue(`Available QTY :`, availableQuantity)}
                {this.labelValue(`Picking QTY :`, remainingQuantity, true)}
              </div>

              <Divider />
              <label htmlFor="">Confirm Picking quantity</label>

              <div className="flexDiv">
                <InputNumber
                  size="large"
                  min={0}
                  value={currRackQty}
                  style={{ width: "100%" }}
                  max={checkQty}
                  onKeyDown={() =>
                    this.setState({
                      disableSubmit: true,
                      finalRackQty: null,
                    })
                  }
                  onChange={(e) => this.checkPickingQty(e, checkQty)}
                />

                <button
                  className="bbtn"
                  onClick={() =>
                    this.setState({
                      finalRackQty: currRackQty,
                      disableSubmit: false,
                    })
                  }
                >
                  Submit
                </button>
              </div>

              {typeof finalRackQty == "number" && finalRackQty < checkQty ? (
                <>
                  <Divider>Partial Picking ?</Divider>

                  <Select
                    showSearch
                    placeholder="Select Reason for partial picking"
                    optionFilterProp="children"
                    style={{ width: "100%" }}
                    disabled={
                      typeof this.state.currRackQty !== "number" ||
                      currRackQty >= checkQty
                    }
                    size="large"
                    value={this.state.currReason}
                    onChange={(value) =>
                      this.setState({
                        currReason: value,
                        disableSubmit: false,
                      })
                    }
                  >
                    {this.state.runnerData?.map((i, l) => (
                      <Option key={l} value={i.reasonId}>
                        {i.value}
                      </Option>
                    ))}
                  </Select>
                </>
              ) : null}
            </div>
          </PickerRackModalWrapper>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  userInfo: state.authReducer?.AuthData?.userDTO,
  isOnline: state.statusReducer?.isOnline,
  TOReducer: state.TOReducer,
  reasonsListSuccess: state.pickerTOReducer.reasonsListSuccess,
  reasonsListFailure: state.pickerTOReducer.reasonsListFailure,
  markPickerIssueSuccess: state.pickerTOReducer.markPickerIssueSuccess,
  markPickerIssueFailure: state.pickerTOReducer.markPickerIssueFailure,
});

const mapDispatchToProps = {
  getReasonsListThunk,
};

export default connect(mapStateToProps, mapDispatchToProps)(PickerRackLocation);
